import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { OnboardingLayout } from '../Layout';
import { paths } from '@/routes/paths';
import { usePaymentMethods } from '@/api/queries/payments';
import { Spinner } from '@/components/ui/Spinner';

export function OnboardingPaymentEmptyPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pms = usePaymentMethods();

  if (pms.isLoading) {
    return (
      <OnboardingLayout back title={t('onboarding.payment.empty_title')}>
        <Spinner />
      </OnboardingLayout>
    );
  }
  if (pms.data && pms.data.length > 0) {
    navigate(paths.onboardingPaymentCards, { replace: true });
  }

  return (
    <OnboardingLayout back title={t('onboarding.payment.empty_title')}>
      <EmptyState
        icon="💳"
        title={t('onboarding.payment.empty_title')}
        body={t('onboarding.payment.empty_body')}
        action={
          <Button block size="lg" variant="inverted" onClick={() => navigate(paths.onboardingPaymentCards)}>
            {t('onboarding.payment.add_card')}
          </Button>
        }
      />
      <Button block variant="ghost" onClick={() => navigate(paths.onboardingEvacuation)}>
        {t('common.skip')}
      </Button>
    </OnboardingLayout>
  );
}
